var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"magazin-list-entry"},[_c('p',{staticClass:"entry-subtitle"},[_vm._v(_vm._s(_vm.item.$.subtitle))]),_c('h4',{staticClass:"entry-title"},[_vm._v(_vm._s(_vm.item.$.title))]),_c('p',{staticClass:"entry-teaser"},[_vm._v(_vm._s(_vm.stripHtml(_vm.item.$.lead_text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }